import { _defineProperty } from "./index13.js";
import { getDoorDistanceFromRight } from "./index132.js";
import { getStartClashStatus } from "./index137.js";
import { AggNmcsState } from "./index138.js";
import { getCoreCost } from "./index139.js";
import { getCorridorCost } from "./index141.js";
import { getEndClashCost } from "./index142.js";
import { getEntranceCost } from "./index143.js";
import { getFireCoreCost } from "./index144.js";
import { getLengthCost } from "./index145.js";
import { getLiftCoreCost } from "./index146.js";
import { getEfficiencyCost } from "./index147.js";
import { getUnitMixCost } from "./index150.js";
import { NmcsRules } from "./index151.js";
import { getStairCoreCost } from "./index152.js";
import { getDataAndActions } from "./index162.js";
import { getClosingCost } from "./index163.js";
import { RG_TYPE } from "@project-rouge/rg-core";
import { randomWeightedItem } from "@project-rouge/rg-three";
var CorridorType = /* @__PURE__ */ function(CorridorType$1) {
	CorridorType$1["Start"] = "Start";
	CorridorType$1["Middle"] = "Middle";
	CorridorType$1["End"] = "End";
	return CorridorType$1;
}(CorridorType || {});
var AggNmcsRules = class extends NmcsRules {
	constructor(aggRulesProps) {
		const { gap } = aggRulesProps.dataset.aggConfig;
		const { data, actions } = getDataAndActions(aggRulesProps);
		super(new AggNmcsState({
			gap,
			data
		}));
		_defineProperty(this, "actions", void 0);
		_defineProperty(this, "data", void 0);
		this.data = data;
		this.actions = actions;
	}
	isActionValid(state, action, ignoreEntranceCheck) {
		const { gap } = this.data.dataset.aggConfig;
		const unitLength = gap + action.unit.size[0];
		if (!this.isValidForBuildingEntrance(state, action, ignoreEntranceCheck)) return false;
		const totalLengthWithShift = state.totalLength + state.requiredShift;
		const prevUnit = state.sequence[state.sequence.length - 1];
		const isDefinitelyLastApartment = totalLengthWithShift + unitLength > this.data.targetLength - this.data.smallestApartmentSize;
		if (totalLengthWithShift + unitLength > this.data.targetLength) return false;
		if (state.sequence.length === 0 && !this.isValidForClashesAtStart(action, this.data.lockEnds[0])) return false;
		if (isDefinitelyLastApartment && !this.isValidForClashesAtEnd(state, action)) return false;
		if (action.unit.type === RG_TYPE.Apartment && action.unit.data.closeDirection) {
			const closeDirection = action.unit.data.closeDirection;
			const canCloseStart = this.data.canCloseEnds[0] && this.data.endClosingDistances[0] === 0;
			const canCloseEnd = this.data.canCloseEnds[1] && this.data.endClosingDistances[1] === 0;
			const closesAtStart = closeDirection[0] > 0;
			const closesAtEnd = closeDirection[0] < 0;
			const isFirstUnit = state.sequence.length === 0;
			if (closesAtStart && !isFirstUnit) return false;
			if (closesAtStart && !canCloseStart) return false;
			if (closesAtEnd && !canCloseEnd) return false;
			if (closesAtEnd && !isDefinitelyLastApartment) return false;
		}
		if (prevUnit && prevUnit.unit.type === RG_TYPE.Apartment && prevUnit.unit.data.closeCorridor) {
			const closeDirection = prevUnit.unit.data.closeDirection;
			if (closeDirection && closeDirection[0] < 0) return false;
		}
		if (!this.isValidForSkipCores(action)) return false;
		if (!this.isValidForFireCores(state, action)) return false;
		if (!this.isValidForCorridorDistances(state, action, totalLengthWithShift, prevUnit, unitLength)) return false;
		return true;
	}
	isValidForBuildingEntrance(state, action, ignoreEntranceCheck) {
		if (action.unit.type === RG_TYPE.Entrance) {
			if (state.entranceCount + 1 > this.data.targetEntranceCount) return false;
			const tempState = state.clone();
			tempState.update(action);
			if (!this.actions.filter((a) => a.unit.type === RG_TYPE.Apartment && a.unit.data.nextToEntrance).some((n) => this.isActionValid(tempState, n))) return false;
			if (!this.actions.filter((a) => a.unit.type === RG_TYPE.Apartment && a.unit.data.aboveEntrance).some((n) => this.isActionValid(state, n, true))) return false;
		}
		if (state.sequence.length === 0 && this.data.hasEntryAtStart && !ignoreEntranceCheck) {
			if (action.unit.type !== RG_TYPE.Entrance) return false;
		}
		let isRequiredByEntrance = false;
		const prevUnit = state.sequence[state.sequence.length - 1];
		if (prevUnit && prevUnit.unit.type === RG_TYPE.Entrance) if (!this.data.dataset.apartments.nextToEntrance.map((a) => a.name).includes(action.unit.name)) return false;
		else isRequiredByEntrance = true;
		if (action.rolloutWeight === 0 && !isRequiredByEntrance) return false;
		return true;
	}
	getValidActions(state) {
		const allActions = this.actions;
		const validActions = [];
		for (const action of allActions) if (this.isActionValid(state, action)) validActions.push(action);
		return validActions;
	}
	getCost(state) {
		const corridorCost = this.data.weights.corridorLengthWeight * getCorridorCost(state, this.data);
		const coreCost = this.data.weights.coreCountWeight * getCoreCost(state, this.data);
		const lengthCost = this.data.weights.totalLengthWeight * getLengthCost(state, this.data);
		const unitMixCost = this.data.weights.unitMixWeight * getUnitMixCost(state, this.data);
		const entranceCost = this.data.weights.entranceCountWeight * getEntranceCost(state, this.data);
		const fireCoreCost = 1 * getFireCoreCost(state, this.data);
		const liftCoreCost = 1 * getLiftCoreCost(state, this.data);
		const stairCoreCost = 1 * getStairCoreCost(state, this.data);
		const efficiencyCost = this.data.weights.efficiencyWeight * getEfficiencyCost(state);
		const endClashCost = 1 * getEndClashCost(state, this.data);
		const closingCost = this.data.weights.closingWeight * getClosingCost(state, this.data);
		return corridorCost + coreCost + lengthCost + unitMixCost + entranceCost + fireCoreCost + liftCoreCost + stairCoreCost + efficiencyCost + endClashCost + closingCost;
	}
	pickActionWithPolicy(validActions, rng) {
		if (validActions.length === 1) return validActions[0];
		const weights = [];
		for (const action of validActions) weights.push(action.rolloutWeight);
		return randomWeightedItem({
			list: validActions,
			weights,
			rng
		});
	}
	cloneState(state) {
		return state.clone();
	}
	updateState(state, action) {
		state.update(action);
	}
	finalAction(state) {
		state.finalUpdate(this.data);
	}
	isValidForClashesAtStart(action, lockedStart) {
		const startClosingDistance = this.data.endClosingDistances[0];
		const startEntranceDistance = this.data.endEntranceDistances[0];
		return getStartClashStatus({
			action,
			startClosingDistance,
			startEntranceDistance,
			skipExistingClosingCheck: !lockedStart
		});
	}
	isValidForClashesAtEnd(state, action) {
		let shift = 0;
		if (!this.data.lockEnds[1]) shift = this.data.targetLength - (state.totalLength + this.data.dataset.aggConfig.gap + action.unit.size[0]);
		if (this.data.endClosingDistances[1] > 0) {
			if (getDoorDistanceFromRight(action) + shift < this.data.endClosingDistances[1]) return false;
			if (action.unit.type === RG_TYPE.Apartment && action.unit.data.closeCorridor) return false;
		}
		if (action.unit.type === RG_TYPE.Apartment && action.unit.data.closeCorridor) {
			if (action.unit.data.closeLength + shift > this.data.endEntranceDistances[1]) return false;
		}
		return true;
	}
	isValidForCorridorDistances(state, action, totalLengthWithShift, prevUnit, unitLength) {
		if (this.data.skipCores) return true;
		const corridorDists = state.corridorLengths;
		const currentCorridorLength = corridorDists[corridorDists.length - 1] ?? 0;
		const lengthRemaining = this.data.targetLength - totalLengthWithShift;
		const { corridorType, maxCorridorDist } = this.getCorridorTypeAndDistance(corridorDists, lengthRemaining);
		if (action.unit.type === RG_TYPE.Core) {
			if (prevUnit && prevUnit.unit.type === RG_TYPE.Core) return false;
		} else if (!prevUnit && corridorType === CorridorType.Start && !this.data.hasCornerAt[0]) {
			if (Math.max(getDoorDistanceFromRight(action), unitLength - this.data.endEntranceDistances[0]) > maxCorridorDist) return false;
		} else if (corridorType === CorridorType.End && !this.data.hasCornerAt[1]) {
			if (currentCorridorLength + action.doorPosition > maxCorridorDist) return false;
		} else if (currentCorridorLength + unitLength > maxCorridorDist) return false;
		return true;
	}
	isValidForSkipCores(action) {
		if (this.data.skipCores && action.unit.type === RG_TYPE.Core) return false;
		return true;
	}
	isValidForFireCores(state, action) {
		if (action.unit.type === RG_TYPE.Core) {
			if (action.unit.data.hasFireLift) {
				if (state.fireCoreCount + 1 > this.data.targetFireCoreCount) return false;
			}
			if (action.unit.data.hasNonFireLift) {
				if (state.liftCoreCount + 1 > this.data.targetLiftCoreCount) return false;
			}
		}
		return true;
	}
	getCorridorTypeAndDistance(corridorDists, lengthRemaining) {
		let corridorType;
		const allowableEndDist = this.data.maxCorridorDists.end - this.data.distToCore[1];
		if (lengthRemaining + corridorDists[corridorDists.length - 1] <= allowableEndDist + this.data.minDoorPositionFromEnd) corridorType = CorridorType.End;
		else if (corridorDists.length <= 1) corridorType = CorridorType.Start;
		else corridorType = CorridorType.Middle;
		let maxCorridorDist;
		if (corridorType === CorridorType.Start) maxCorridorDist = this.data.maxCorridorDists.start;
		else if (corridorType === CorridorType.Middle) maxCorridorDist = this.data.maxCorridorDists.middle;
		else maxCorridorDist = allowableEndDist;
		return {
			corridorType,
			maxCorridorDist
		};
	}
};
export { AggNmcsRules };

//# sourceMappingURL=index164.js.map